var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('img',{key:_vm.tempdata.chart_base64,staticClass:"w-full rounded-sm shadow-md",attrs:{"src":_vm.tempdata.chart_base64,"alt":_vm.tempdata.player_id}})])}
var staticRenderFns = []

export { render, staticRenderFns }